module.exports = __webpack_public_path__ + "static/media/bytt-no-17.e83c8e55.mp3";